export function getUrlParams () {
  var url = location.search

  var o = {}
  // 过滤参数中的html相关字符串
  // eslint-disable-next-line no-control-regex
  var reg = /"|&|'|<|>|[\x00-\x20]|[\x7F-\xFF]|[\u0100-\u2700]/g
  if (url.indexOf('?') != -1) {
    var strs = url.substr(1)
    strs = strs.split('&')
    for (var i = 0; i < strs.length; i++) {
      var item = strs[i].split('=')
      if (item[1]) {
        var relStr = decodeURIComponent(item[1])
        if (!reg.test(relStr)) {
          o[item[0]] = relStr
        }
      }
    }
  }
  return o
}

export function isLtIE11 () {
  var userAgent = navigator.userAgent 
  return userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1
}

export function doPageJump(parmas) {
  const oldParams = getUrlParams()
  let newParams = {
    ...oldParams,
    ...parmas
  }
  let finalParams = {}
  for(let key in newParams){
    if (newParams[key] && key !== 'page') {
      finalParams[key] = newParams[key]
    }
  }
  let str = JSON.stringify(finalParams)
              .replace(/:/g, '=')
              .replace(/,/g, '&')
              .replace(/"/g, '')
              .replace(/\{/g, '')
              .replace(/\}/g, '')

  // window.history.pushState(null, null, `?${str}`)
  window.location.href = `/so-index.html?${str}`
}

// 生成 guid
export function guid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8)
    return v.toString(16)
  })
}

// 获取指定名称的cookie
export function getCookie(name){
  var strcookie = document.cookie;
  var arrcookie = strcookie.split("; ");

  for ( var i = 0; i < arrcookie.length; i++) {
      var arr = arrcookie[i].split("=");
      if (arr[0] == name){
          return arr[1];
      }
  }
  return "";
}


export const $ = {
  addClass(el, cls) {
    let currCls = el.getAttribute('class') || ''
    if (!~currCls.indexOf(cls)) {
      currCls = currCls.replace(/\s+/g, ' ').trim() + ` ${cls}`
      el.setAttribute('class', currCls)
    }
  },
  removeClass(el, cls) {
    let currCls = el.getAttribute('class')
    currCls = currCls
      .replace(cls, '')
      .replace(/\s+/g, ' ')
      .trim()
    el.setAttribute('class', currCls)
  },
  removeElement(_element) {
    var _parentElement = _element.parentNode
    if (_parentElement) {
      _parentElement.removeChild(_element)
    }
  },

  getTop(el) {
    el = el || document.documentElement
    return (
      el.getBoundingClientRect().top +
      (document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop)
    )
  },

  /**
   * 获取客户端高度
   */
  getClientHeight() {
    return window.innerHeight || document.documentElement.clientHeight
  },

  /**
   * 获取客户端宽度
   */
  getClientWidth() {
    return window.innerWidth || document.documentElement.clientWidth
  },


  /**
   * 获取滚动条位置
   */
  getScrollTop() {
    /* return document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
    return document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop */
    let scrollTop = 0
    if (document.documentElement && document.documentElement.scrollTop) {
      scrollTop = document.documentElement.scrollTop
    } else if (document.body) {
      scrollTop = document.body.scrollTop
    } else if (window.pageYOffset) {
      scrollTop = window.pageXOffset
    }
    return scrollTop
  },

  /**
   * 获取浏览器所有内容高度
   */
  getScrollHeight() {
    return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight)
  },
}

// 判断元素是否在可视区域内
export function isInViewPort(el) {
  const viewWidth = window.innerWidth || document.documentElement.clientWidth
  const viewHeight = window.innerHeight || document.documentElement.clientHeight
  const {
    top,
    right,
    bottom,
    left,
    width,
    height
  } = el.getBoundingClientRect();
  // console.log(viewWidth)
  // console.log(viewHeight)
  // console.log(el.getBoundingClientRect())
  const referWidth = width * 0.5
  const referHeight = height * 0.5
  return (
    (top >= 0 || Math.abs(top) <= referHeight) &&
    (left >= 0 || Math.abs(left) <= referWidth) &&
    right <= viewWidth + referWidth &&
    bottom <= viewHeight + referHeight
  )
}